<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont icontiku1"></i>
      {{ id ? '评分表编辑' : '评分表新增' }}
    </div>
    <div class="padding-sm">
      <el-form :model="scoreForm" :rules="rules" ref="scoreForm" label-width="100px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="scoreForm.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input v-model="scoreForm.desc" type="textarea" placeholder="请输入描述"></el-input>
        </el-form-item>
        <el-form-item label="报名类型" prop="type">
          <el-select v-model="scoreForm.type" placeholder="请选择报名类型" style="width: 100%">
            <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-radio-group v-model="group">
            <el-radio-button :label="1" v-if="scoreForm.type===1">团队成绩</el-radio-button>
            <el-radio-button :label="2">个人成绩</el-radio-button>
          </el-radio-group>
          <div class="margin-top-sm">
            <el-table
                v-show="group === 1"
                :data="scoreForm.formList1"
                row-class-name="table-row"
                alig="center"
                border
                style="width: 100%">
              <el-table-column label="评价内容">
                <template slot-scope="scope">
                  <div class="table-item">
                    {{ scope.row.name }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="成绩">
                <template slot-scope="scope">
                  <div class="table-item">
                    {{ scope.row.scoreText.join(',') }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <div class="table-operate">
                    <el-button
                        size="medium"
                        type="primary"
                        @click="editItem(scope.row,scope.$index)"
                    >编辑
                    </el-button>
                    <el-button
                        size="medium"
                        type="danger"
                        @click="delItem(scope.$index)"
                    >删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-table
                v-show="group===2"
                :data="scoreForm.formList2"
                row-class-name="table-row"
                alig="center"
                border
                style="width: 100%">
              <el-table-column label="评价项">
                <template slot-scope="scope">
                  <div class="table-item">
                    {{ scope.row.content }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="评价内容">
                <template slot-scope="scope">
                  <div class="table-item">
                    {{ scope.row.name }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="成绩">
                <template slot-scope="scope">
                  <div class="table-item">
                    {{ scope.row.scoreText.join(',') }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <div class="table-operate">
                    <el-button
                        size="medium"
                        type="primary"
                        @click="editItem(scope.row,scope.$index)"
                    >编辑
                    </el-button>
                    <el-button
                        size="medium"
                        type="danger"
                        @click="delItem(scope.$index)"
                    >删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="flex align-center justify-around">
              <el-button
                  class="margin-top"
                  size="medium"
                  type="primary"
                  @click="subdialogDialog = true"
              >编辑
              </el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="flex align-center justify-around" label-width="0">
          <el-button class="padding-lr-xl" @click="resetForm('scoreForm')">取消</el-button>
          <el-button class="padding-lr-xl" type="primary" @click="submitForm('scoreForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <subdialog-dialog
        :group="group"
        :setId="setId"
        :setItem="setItem"
        :subdialogDialog="subdialogDialog"
        @cancelDialog="cancelDialog"
    />

  </div>
</template>

<script>
import {scoreInfo, scoreAdd} from "@/api/projectOffice";
import subdialogDialog from "@/views/projectOffice/page/dialog/scoreDialog";

export default {
  name: "score",
  data() {
    return {
      id: '',
      types: [
        {
          id: 1,
          name: '专业考官'
        },
        {
          id: 2,
          name: 'HR考官'
        }
      ],
      group: 1,
      scoreForm: {
        name: '',
        desc: '',
        type: '',
        formList1: [],
        formList2: [],
      },
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],
        desc: [
          {required: true, message: '请输入描述', trigger: 'blur'},
        ],
        type: [{required: true, message: '请选择考试类型', trigger: 'change'}]
      },
      setId: -1,
      setItem: {},
      subdialogDialog: false
    };
  },
  components: {
    subdialogDialog
  },
  created() {
    this.$emit(
        "setIndex",
        '/projectOffice/score',
        "当前位置：评分管理 > 评分表编辑",
        true
    );
    if (this.$route.query.id) this.id = this.$route.query.id , this.getDetail()
  },
  methods: {
    async getDetail() {
      let _data = await scoreInfo(this.id)
      _data.data.group.map(item => {
        this.scoreForm.formList1.push({
          name: item.name,
          content: item.content,
          scoreValue: item.score.split(',').map(Number),
          scoreText: item.value.split(','),
          score: item.ids.split(',').map(Number),
        })
      })
      _data.data.single.map(item => {
        this.scoreForm.formList2.push({
          name: item.name,
          content: item.content,
          scoreValue: item.score.split(',').map(Number),
          scoreText: item.value.split(','),
          score: item.ids.split(',').map(Number),
        })
      })

      this.scoreForm.name = _data.data.name
      this.scoreForm.desc = _data.data.desc
      this.scoreForm.type = Number(_data.data.type)

    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _group = []
      let _single = []
      if(this.scoreForm.type ===1){
        this.scoreForm.formList1.map(item => {
          let _score = item.scoreValue.join(',')
          let _scoretext = item.scoreText.join(',')
          let _scoreid = item.score.join(',')
          _group.push({
            name: item.name,
            score: _score,
            value: _scoretext,
            ids: _scoreid
          })
        })
      }
      this.scoreForm.formList2.map(item => {
        let _score = item.scoreValue.join(',')
        let _scoretext = item.scoreText.join(',')
        let _scoreid = item.score.join(',')
        _single.push({
          name: item.name,
          content: item.content,
          score: _score,
          value: _scoretext,
          ids: _scoreid
        })
      })
      let _data = await scoreAdd(this.scoreForm.name, this.scoreForm.desc, this.scoreForm.type, JSON.stringify(_group), JSON.stringify(_single), this.id ? this.id : '',);
      this.$message.success(_data.msg);
      this.$router.go(-1)
    },
    editItem(obj, index) {
      if (obj) {
        this.setItem = obj;
        this.setId = index;
      }
      this.subdialogDialog = true;
    },
    cancelDialog(val) {
      if (val[0]) {
        if (this.setId >= 0) {
          if (this.group === 1) {
            this.$set(this.scoreForm.formList1, this.setId, val[1])
          } else {
            this.$set(this.scoreForm.formList2, this.setId, val[1])
          }
        } else {
          console.log(val[1])
          if (this.group === 1) {
            this.scoreForm.formList1.push(val[1])
          } else {
            this.scoreForm.formList2.push(val[1])
          }
        }


        this.setId = -1;
        this.setItem = {};
        this.subdialogDialog = false;
      } else {
        this.setId = -1;
        this.setItem = {};
        this.subdialogDialog = false;
      }
    },
    delItem(index){
      this.$confirm("确定要删除该评分吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
       if(this.group === 1){
         this.scoreForm.formList1.splice(index,1)
       }else{
         this.scoreForm.formList2.splice(index,1)
       }
      });
    }
  },
  watch:{
    'scoreForm.type'(){
      if(this.scoreForm.type === 2){
        this.group = 2
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
